(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camp-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-countdown]').forEach((countdown) => {
    const date = countdown.dataset.endDate;
    if (!date) return;
    const target = new Date(`${date}T${countdown.dataset.endTime || '23:59'}:00`).getTime();
    const end = countdown.querySelector('[data-countdown-end]');
    const fields = {
      days: countdown.querySelector('[data-countdown-days]'),
      hours: countdown.querySelector('[data-countdown-hours]'),
      minutes: countdown.querySelector('[data-countdown-minutes]'),
      seconds: countdown.querySelector('[data-countdown-seconds]')
    };
    const update = () => {
      const remaining = Math.max(0, target - Date.now());
      const values = {
        days: Math.floor(remaining / 86400000),
        hours: Math.floor(remaining / 3600000) % 24,
        minutes: Math.floor(remaining / 60000) % 60,
        seconds: Math.floor(remaining / 1000) % 60
      };
      Object.entries(values).forEach(([key, value]) => {
        if (fields[key]) fields[key].textContent = String(value).padStart(2, '0');
      });
      if (remaining > 0) return;
      if (end) end.hidden = false;
      if (countdown.dataset.hideExpired === 'true') countdown.hidden = true;
      window.clearInterval(timer);
    };
    const timer = window.setInterval(update, 1000);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-wheel-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
const GiftSeasons = (() => {
  const keys = ['newyear','seollal','valentine','children','parents','summer','chuseok','hangul','pepero','blackfriday','christmas'];
  const sculpted = new Set(['newyear','seollal','valentine','children','parents','chuseok','hangul','blackfriday','christmas']);
  const koreanSculpted = new Set(['newyear','seollal','children','parents','chuseok','hangul','christmas']);
  const palettes = {
    newyear: [['#173f35','#4e8f74','#08271f','#e3b843','#fff1bf'],['#142642','#5e789f','#071329','#f0c56d','#fff0ba'],['#7b2136','#c86276','#3b0d1b','#e6b95f','#fff0bd']],
    seollal: [['#8c263d','#d96f7f','#43101d','#f0c86f','#fff2c3'],['#173f35','#5f9178','#09261d','#d9ad55','#fff0bd'],['#24395f','#6d83ad','#101c36','#dcb75f','#fff2c9']],
    valentine: [['#9b2f50','#ed7694','#4a1027','#f0bf78','#ffe9d2'],['#b95872','#efabba','#64243a','#f1cd7a','#fff0c9'],['#6d243c','#b75e77','#35101f','#e4b968','#ffe4b7']],
    children: [['#197a70','#55b9a7','#07443f','#ff7b55','#fff0a6'],['#2f67a3','#79aee0','#15365c','#ffc64e','#fff4b5'],['#6a4ca5','#a18ad2','#35235d','#ef8f51','#ffe8ac']],
    parents: [['#8f3553','#df88a5','#421528','#2f7960','#ffe4b6'],['#c15e63','#efa29f','#66282d','#658b54','#fff0bd'],['#693d68','#ac7aa6','#321d34','#d7ad62','#fff0ca']],
    summer: [['#087d6b','#51bda4','#03493d','#ffba35','#fff2a7'],['#176e9e','#66b4d9','#073d59','#f3cf54','#fff2ad'],['#245d46','#79a96f','#103422','#e8a94a','#fff0b8']],
    chuseok: [['#2e6751','#79a477','#123928','#d8a94b','#fff0b5'],['#8a512d','#cf8650','#4b2a16','#d9bd66','#fff0bd'],['#323f6d','#747fa9','#171d3b','#e0b75f','#fff2c6']],
    hangul: [['#163f67','#517ba6','#081f36','#d24a45','#f6e8c6'],['#234f3d','#6e947a','#10291f','#dbb45d','#fff0c4'],['#5b324f','#9a6b8b','#2d1726','#e3bd6d','#fff1cc']],
    pepero: [['#6b3f2a','#a76b45','#342015','#ef7c73','#ffe0bc'],['#7b2743','#c86f88','#3e1222','#ddb667','#fff0c2'],['#3e2c69','#7966a8','#21153c','#e49564','#ffe9c1']],
    blackfriday: [['#20272b','#596168','#080d10','#d5a84f','#fff0ba'],['#111f36','#4d6380','#07101d','#dfba67','#fff2c6'],['#55253d','#986177','#28101d','#d9b161','#ffe9bd']],
    christmas: [['#174f39','#5b9472','#082c1e','#d93643','#ffe6a3'],['#8a2437','#d16a7b','#400d1b','#d9b365','#fff0bd'],['#16385b','#5d7ba1','#071e35','#d83942','#ffe8ac']]
  };
  const dayNumber = (year, month, day) => Date.UTC(year, month - 1, day) / 86400000;
  const nthWeekday = (year, month, weekday, nth) => 1 + (weekday - new Date(Date.UTC(year, month - 1, 1)).getUTCDay() + 7) % 7 + 7 * (nth - 1);
  const seoulDate = now => {
    const fields = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Seoul', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(now).map(part => [part.type, part.value]));
    return { year: +fields.year, month: +fields.month, day: +fields.day, hour: +fields.hour };
  };
  const lunarFormatter = new Intl.DateTimeFormat('en-US-u-ca-chinese', { timeZone: 'Asia/Seoul', month: 'numeric', day: 'numeric' });
  const lunarEvent = (year, targetMonth, targetDay) => {
    for (let index = 0; index < 367; index += 1) {
      const candidate = new Date(Date.UTC(year, 0, 1 + index, 6));
      if (candidate.getUTCFullYear() !== year) break;
      const fields = Object.fromEntries(lunarFormatter.formatToParts(candidate).map(part => [part.type, part.value]));
      if (Number.parseInt(fields.month, 10) === targetMonth && Number(fields.day) === targetDay && !String(fields.month).toLowerCase().includes('bis')) {
        return dayNumber(candidate.getUTCFullYear(), candidate.getUTCMonth() + 1, candidate.getUTCDate());
      }
    }
    return null;
  };
  const events = year => {
    const seollal = lunarEvent(year, 1, 1);
    const chuseok = lunarEvent(year, 8, 15);
    const blackFriday = dayNumber(year, 11, nthWeekday(year, 11, 4, 4) + 1);
    return [
      { key: 'newyear', date: dayNumber(year, 1, 1), tail: 1 },
      ...(seollal ? [{ key: 'seollal', date: seollal, tail: 2 }] : []),
      { key: 'valentine', date: dayNumber(year, 2, 14), tail: 0 },
      { key: 'children', date: dayNumber(year, 5, 5), tail: 0 },
      { key: 'parents', date: dayNumber(year, 5, 8), tail: 1 },
      { key: 'summer', date: dayNumber(year, 7, 15), tail: 25 },
      ...(chuseok ? [{ key: 'chuseok', date: chuseok, tail: 2 }] : []),
      { key: 'pepero', date: dayNumber(year, 11, 11), tail: 0 },
      { key: 'blackfriday', date: blackFriday, tail: 3 },
      { key: 'christmas', date: dayNumber(year, 12, 25), tail: 1 }
    ];
  };
  const dailyOrder = (date, holiday) => {
    const seed = `cyfie-gift-8h-v1|${date}|${holiday}`;
    let hash = 2166136261;
    for (let index = 0; index < seed.length; index += 1) hash = Math.imul(hash ^ seed.charCodeAt(index), 16777619) >>> 0;
    hash = Math.imul(hash ^ (hash >>> 16), 0x7feb352d) >>> 0;
    hash = Math.imul(hash ^ (hash >>> 15), 0x846ca68b) >>> 0;
    hash = (hash ^ (hash >>> 16)) >>> 0;
    return [[1,2,3],[1,3,2],[2,1,3],[2,3,1],[3,1,2],[3,2,1]][hash % 6].slice();
  };
  const resolve = (config, now = new Date()) => {
    const date = seoulDate(now);
    const today = dayNumber(date.year, date.month, date.day);
    let holiday = 'brand';
    if (config.enabled !== false && config.mode !== 'brand') {
      if (keys.includes(config.mode)) holiday = config.mode;
      else {
        const enabled = config.holidays || keys;
        const lead = Math.max(0, Math.min(30, Number(config.leadDays) || 0));
        const matches = [...events(date.year - 1), ...events(date.year), ...events(date.year + 1)]
          .filter(event => enabled.includes(event.key) && today >= event.date - lead && today <= event.date + event.tail)
          .sort((a, b) => Math.abs(a.date - today) - Math.abs(b.date - today));
        if (matches[0]) holiday = matches[0].key;
      }
    }
    const dateKey = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
    const order = dailyOrder(dateKey, holiday);
    const slot = Math.min(2, Math.floor(date.hour / 8));
    const style = config.variant || 'auto8h';
    const variant = style === 'auto8h' ? (holiday === 'brand' ? 1 : order[slot]) : style === 'rotate' ? today % 3 + 1 : Math.max(1, Math.min(3, Number(style) || 1));
    return { holiday, variant, palette: palettes[holiday]?.[variant - 1], date: dateKey, slot, order, automatic: style === 'auto8h' };
  };
  const assetUrl = (root, chosen) => {
    if (chosen.holiday === 'brand') return root.dataset.dailyArtUrl;
    if (chosen.holiday === 'pepero') return root.dataset.premiumArtUrl;
    if (!sculpted.has(chosen.holiday)) return null;
    return root.getAttribute(`data-sculpture-url-${chosen.holiday}-${chosen.variant}`);
  };
  const preload = (root, chosen) => {
    const url = assetUrl(root, chosen);
    if (!url) return Promise.resolve();
    const link = document.createElement('link');
    link.rel = 'preload'; link.as = 'image'; link.href = url; link.fetchPriority = 'high';
    document.head.append(link);
    const image = new Image(); image.loading = 'eager'; image.src = url;
    return image.decode().finally(() => link.remove());
  };
  const apply = (root, config, now) => {
    const chosen = resolve(config, now);
    const url = assetUrl(root, chosen);
    root.dataset.holiday = chosen.holiday;
    root.dataset.skin = String(chosen.variant);
    root.dataset.holidayDate = chosen.date;
    root.dataset.seasonSlot = String(chosen.slot);
    root.dataset.seasonOrder = chosen.order.join(',');
    root.dataset.seasonRotation = chosen.automatic ? '8h' : 'manual';
    root.dataset.sculpture = String(Boolean(url) && chosen.holiday !== 'brand' && chosen.holiday !== 'pepero');
    root.dataset.premiumBox = String(chosen.holiday === 'pepero' && Boolean(url));
    root.dataset.koreanSculpture = String(koreanSculpted.has(chosen.holiday));
    if (url) root.querySelectorAll('[data-halloween-image]').forEach(image => { if (image.getAttribute('src') !== url) image.src = url; });
    if (chosen.palette) {
      ['body','light','dark','ribbon','gold'].forEach((key, index) => root.style.setProperty(`--gift-${key}`, chosen.palette[index]));
      root.querySelectorAll('[data-holiday-icon]').forEach(use => use.setAttribute('href', `#GiftIcon-${root.dataset.iconId}-${chosen.holiday}`));
    } else {
      ['body','light','dark','ribbon','gold'].forEach(key => root.style.removeProperty(`--gift-${key}`));
    }
    return chosen;
  };
  return { keys, palettes, events, seoulDate, dailyOrder, resolve, assetUrl, preload, apply };
})();


// The opening is measured on each artwork, in the 340 × 640 stage.
// A matching foreground rim and pocket mask keep the card inside the vessel.
const GiftMouth = (() => {
  const profiles = {"brand":[[170,395,120,18],[170,395,120,18],[170,395,120,18]],"halloween":[[166,460,82,14],[230,451,97,14],[194,450,111,17]],"christmas":[[170,434,132,18],[148,426,98,15],[170,429,74,18]],"newyear":[[170,429,110,20],[170,426,111,19],[170,426,104,16]],"valentine":[[170,447,127,25],[170,479,120,28],[170,432,108,16]],"easter":[[170,427,104,17],[226,452,72,17],[170,457,132,22]],"mothers":[[170,454,111,22],[170,465,108,26],[170,430,108,19]],"memorial":[[170,475,92,22],[170,424,99,16],[170,427,101,15]],"fathers":[[194,477,75,15],[170,458,127,23],[170,450,120,24]],"independence":[[170,452,84,21],[170,425,67,16],[170,426,83,17]],"labor":[[170,469,130,21],[213,459,83,17],[170,468,120,22]],"thanksgiving":[[170,430,115,20],[138,471,73,18],[170,427,99,19]],"blackfriday":[[170,459,94,16],[170,426,112,15],[170,434,106,19]]};
  Object.assign(profiles,{
    brand:[[143.0033,464.778636,114.950495,23.275912],[143.0033,464.778636,114.950495,23.275912],[143.0033,464.778636,114.950495,23.275912]],
    newyear:[[170,420,124,20],[170,420,124,20],[170,420,124,20]],
    seollal:[[170,420,124,20],[170,420,124,20],[170,420,124,20]],
    children:[[170,425,124,20],[170,425,124,20],[170,425,124,20]],
    parents:[[170,438,124,22],[170,438,124,22],[170,438,124,22]],
    chuseok:[[170,420,124,20],[170,420,124,20],[170,420,124,20]],
    hangul:[[170,420,124,20],[170,420,124,20],[170,420,124,20]],
    christmas:[[170,420,124,20],[170,420,124,20],[170,420,124,20]]
  });
  // Sample the inner lip of each active sprite, before its CSS crop/scale.
  // The closed artwork is separate and keeps its approved dimensions.
  const spriteOpenings={
    newyear:{mouth:[512,414.5,207,34.5],frame:[361,855]},
    seollal:{mouth:[512,414.5,207,34.5],frame:[361,855]},
    children:{mouth:[511.5,499.5,255.5,62.5],frame:[427,891]},
    parents:{mouth:[512,492.5,239,62.5],frame:[391,864]},
    chuseok:{mouth:[512,380,209,35],frame:[330,812],notch:[420,600,790]},
    hangul:{mouth:[513,501,277,56],frame:[433,881]},
    christmas:{mouth:[512,411,158,34],frame:[366,817]}
  };
  profiles.valentine=[[170,422,127,48],[170,448,112,54],[170,432,108,16]];
  profiles.blackfriday[2]=[170,431,106,17];
  const clamp = value => Math.max(0,Math.min(1,value));
  const smooth = value => { const p=clamp(value);return p*p*(3-2*p); };
  const polygon = points => `polygon(${points.map(([x,y])=>`${x.toFixed(2)}px ${y.toFixed(2)}px`).join(',')})`;
  const prepare = root => {
    const pocket=root.querySelector('.gift-pocket'),front=root.querySelector('.gift-front');
    const sourceStyles=new Map();
    let artworkKey='',spriteMouth=null;
    const ownStyle=(element,property,value)=>{
      if(!sourceStyles.has(element)) sourceStyles.set(element,new Map());
      const saved=sourceStyles.get(element);
      if(!saved.has(property)) saved.set(property,element.style.getPropertyValue(property));
      element.style.setProperty(property,value);
    };
    const syncArtwork=()=>{
      const selected=[root.dataset.holiday,root.dataset.skin,root.dataset.koreanSculpture].join('|');
      if(selected===artworkKey) return;
      for(const [element,saved] of sourceStyles) for(const [property,value] of saved){
        if(value) element.style.setProperty(property,value);else element.style.removeProperty(property);
      }
      sourceStyles.clear();spriteMouth=null;artworkKey=selected;
      const source=root.dataset.koreanSculpture==='true'?spriteOpenings[root.dataset.holiday]:null;
      if(!source) return;
      // These modes share one source image across skins; discard crop coordinates
      // inherited from the older, differently shaped source images.
      const alias=root.dataset.holiday==='newyear'?'seollal':root.dataset.holiday==='christmas'?'christmas':null;
      if(alias){
        const openStyles=alias==='seollal'
          ? {lid:{width:'512px',height:'768px',left:'-64px',top:'0px','clip-path':'inset(0 15% 73% 15%)'},base:{width:'512px',height:'768px',left:'-86px',top:'-196px'}}
          : {lid:{width:'447.7023px',height:'671.5535px',left:'-31.6326px',top:'8px','clip-path':'inset(0 22.55859% 72.00521% 22.46094%)'},base:{width:'571.6164px',height:'857.4247px',left:'-116.3664px',top:'-246.7637px'}};
        for(const part of ['lid','base','front']){
          const image=root.querySelector(`[data-halloween-part='${part}'] img`);
          if(image) for(const [property,value] of Object.entries(openStyles[part==='lid'?'lid':'base'])) ownStyle(image,property,value);
        }
        const label=root.querySelector('.gift-sculpture-brand');
        if(label) ownStyle(label,'top','535px');
      }
      const lidArt=root.querySelector('.gift-lid [data-halloween-part]');
      const lidImage=lidArt?.querySelector('img');
      if(lidImage){
        const imageStyle=getComputedStyle(lidImage);
        const frameBottom=Number.parseFloat(imageStyle.top)+source.frame[0]*Number.parseFloat(imageStyle.height)/1536;
        // Intersect the existing image crop, retaining each skin's side margins.
        ownStyle(lidArt,'clip-path',`inset(0 0 ${Math.max(0,Number.parseFloat(getComputedStyle(lidArt).height)-frameBottom)}px 0)`);
      }
      for(const part of [root.querySelector('.gift-base'),front]){
        const img=part?.querySelector('[data-halloween-part] img');
        if(!img) continue;
        const imageStyle=getComputedStyle(img),partStyle=getComputedStyle(part);
        const scaleX=Number.parseFloat(imageStyle.width)/1024,scaleY=Number.parseFloat(imageStyle.height)/1536;
        const offsetX=part.offsetLeft+Number.parseFloat(imageStyle.left),offsetY=part.offsetTop+Number.parseFloat(imageStyle.top);
        if(part===front) spriteMouth=source.mouth.map((value,index)=>index===0?offsetX+value*scaleX:index===1?offsetY+value*scaleY:value*(index===2?scaleX:scaleY));
        // Reveal the complete opening without moving or stretching the bitmap.
        const expand=Math.max(0,Math.ceil(part.offsetTop-(offsetY+source.frame[0]*scaleY))+1);
        if(expand){
          ownStyle(part,'top',`${part.offsetTop-expand}px`);
          ownStyle(part,'height',`${Number.parseFloat(partStyle.height)+expand}px`);
          ownStyle(img,'top',`${Number.parseFloat(imageStyle.top)+expand}px`);
        }
        const [top,bottom]=source.frame;
        const frame=[[0,top],[1024,top],[1024,bottom]];
        if(source.notch){const [left,right,y]=source.notch;frame.push([right,bottom],[right,y],[left,y],[left,bottom]);}
        frame.push([0,bottom]);
        ownStyle(img,'clip-path',`polygon(${frame.map(([x,y])=>`${x/1024*100}% ${y/1536*100}%`).join(',')})`);
      }
    };
    const dailyOpening=[[28.052805,458.054484],[257.953795,471.502789],[300.173266,431.675117],[86.947194,418.226812]];
    const dailyRim=[[22.021452,459.606211],[259.727722,473.571759],[307.623762,430.640632]];
    // The non-sculpted holiday artwork has a trapezoid opening, not a bowl.
    // These points are the inner gold opening in gift-season-art's viewBox.
    const svgOpening=[[77,55],[313,55],[285,99],[49,99]];
    const premiumOpening=[[376,434],[792,469],[667,592],[231,552]];
    const sculptedFrontRims={
      'valentine-1':[[222,482],[226,493],[240,505],[256,516],[288,531],[320,543],[352,554],[384,563],[416,570],[448,575],[480,580],[512,584],[544,580],[576,574],[608,569],[640,562],[672,554],[704,543],[736,531],[768,516],[792,501],[800,489],[801,481]],
      'valentine-2':[[250,548],[258,558],[276,568],[300,580],[320,587],[344,594],[360,600],[372,606],[384,612],[396,622],[406,630],[420,634],[448,637],[480,640],[496,640],[502,637],[512,635],[522,637],[530,640],[544,640],[576,637],[604,634],[618,630],[628,622],[640,612],[652,606],[664,600],[680,594],[704,587],[724,580],[748,568],[766,558],[774,548]],
      'valentine-3':[[267,480],[271,493],[288,511],[320,523],[352,537],[384,546],[416,550],[448,554],[480,557],[512,557],[544,555],[576,553],[608,550],[640,546],[672,538],[704,530],[736,514],[752,501],[760,486],[761,478]],
      'blackfriday-1':[[242,480],[248,487],[256,493],[272,506],[288,516],[304,524],[320,527],[352,527],[384,528],[400,534],[416,538],[448,547],[480,552],[512,552],[544,547],[560,543],[576,539],[592,533],[608,530],[640,529],[672,528],[704,521],[720,515],[736,506],[748,494],[758,485],[758,478]],
      'blackfriday-2':[[280,486],[288,500],[304,511],[320,518],[352,528],[384,534],[416,538],[448,541],[480,543],[512,543],[544,543],[576,541],[608,538],[640,533],[672,528],[704,518],[720,511],[736,500],[744,486]],
      'blackfriday-3':[[240,441],[248,448],[256,451],[288,466],[320,476],[352,482],[384,488],[416,491],[448,493],[480,494],[512,494],[544,494],[576,493],[608,491],[640,488],[672,482],[704,476],[736,466],[768,452],[780,441]]
    };
    let key='',geometryKey='',mouth,opening,backLipY,foreground;
    return (ticket,progress,floatY,horizontalScale=1,baseLift=0,sceneScale=1,targetCardWidth=224) => {
      const width=ticket.offsetWidth,height=ticket.offsetHeight;
      if(!front.offsetWidth || !front.offsetHeight || !width || !height) {
        key='';geometryKey='';ticket.style.opacity='0';return;
      }
      syncArtwork();
      const daily=root.dataset.holiday==='brand';
      const premium=root.dataset.premiumBox==='true';
      const rectangular=premium || !daily && root.dataset.sculpture!=='true';
      const style=getComputedStyle(front);
      const svg=rectangular&&!premium?front.querySelector('svg.gift-season-art'):null;
      const viewBox=svg?.viewBox.baseVal;
      if(rectangular && !premium && (!viewBox?.width || !viewBox.height)) {
        key='';geometryKey='';ticket.style.opacity='0';return;
      }
      const rimEdge=dailyRim.map(([x,y])=>[x,y-baseLift]);
      const selected=[root.dataset.holiday,root.dataset.skin,root.dataset.sculpture,premium,baseLift.toFixed(3),rectangular?`${front.offsetLeft},${front.offsetTop},${style.width},${style.height},${viewBox?.x||0},${viewBox?.y||0},${viewBox?.width||0},${viewBox?.height||0}`:''].join('|');
      if(selected!==key) {
        key=selected;
        if(rectangular) {
          if(premium){
            const image=front.querySelector('[data-halloween-part] img');
            const imageStyle=getComputedStyle(image);
            const sx=Number.parseFloat(imageStyle.width)/1024,sy=Number.parseFloat(imageStyle.height)/1536;
            const left=front.offsetLeft+Number.parseFloat(imageStyle.left),top=front.offsetTop+Number.parseFloat(imageStyle.top);
            opening=premiumOpening.map(([x,y])=>[left+x*sx,top+y*sy]);
          }else{
            const viewportWidth=Number.parseFloat(style.width),viewportHeight=Number.parseFloat(style.height);
            const scale=Math.min(viewportWidth/viewBox.width,viewportHeight/viewBox.height);
            const left=front.offsetLeft+(viewportWidth-viewBox.width*scale)/2;
            const top=front.offsetTop+(viewportHeight-viewBox.height*scale)/2;
            opening=svgOpening.map(([x,y])=>[left+(x-viewBox.x)*scale,top+(y-viewBox.y)*scale]);
          }
          const cx=opening.reduce((total,point)=>total+point[0],0)/opening.length;
          const cy=(opening[0][1]+opening[2][1])/2;
          mouth=[cx,cy,(opening[1][0]-opening[0][0])/2,(opening[2][1]-opening[0][1])/2];
        } else {
          opening=dailyOpening.map(([x,y])=>[x,y-baseLift]);
          mouth=(profiles[root.dataset.holiday]||profiles.brand)[Math.max(0,Math.min(2,Number(root.dataset.skin)-1||0))];
          if(spriteMouth) mouth=[spriteMouth[0],Math.min(mouth[1],spriteMouth[1]),Math.min(mouth[2],spriteMouth[2]),Math.min(mouth[3],spriteMouth[3])];
        }
        const [cx,cy,rx,ry]=mouth;
        const arc=Array.from({length:33},(_,i)=>{const angle=Math.PI*i/32;return [cx+rx*Math.cos(angle),cy+ry*Math.sin(angle)];});
        const measuredBack={valentine:[422,451,416],blackfriday:[443,411,415]};
        backLipY=daily?Math.min(...opening.map(point=>point[1])):rectangular?opening[0][1]:spriteMouth?spriteMouth[1]-spriteMouth[3]:(measuredBack[root.dataset.holiday]||[])[Math.max(0,Math.min(2,Number(root.dataset.skin)-1||0))]??cy-ry;
        const clearY=backLipY-2;
        root.dataset.cardBackLip=String(backLipY);
        const sourceRim=root.dataset.sculpture==='true'?sculptedFrontRims[`${root.dataset.holiday}-${root.dataset.skin}`]:null;
        if(sourceRim){
          const imageStyle=getComputedStyle(front.querySelector('[data-halloween-part] img'));
          const sx=Number.parseFloat(imageStyle.width)/1024,sy=Number.parseFloat(imageStyle.height)/1536;
          const left=front.offsetLeft+Number.parseFloat(imageStyle.left),top=front.offsetTop+Number.parseFloat(imageStyle.top);
          foreground=sourceRim.map(([x,y])=>[left+x*sx,top+(y-1)*sy]);
        }else if(spriteMouth){
          const [x,y,rx,ry]=spriteMouth;
          foreground=Array.from({length:33},(_,i)=>{const angle=Math.PI*(1-i/32);return [x+rx*Math.cos(angle),y+ry*Math.sin(angle)];});
        }else foreground=daily?rimEdge:rectangular?[opening[3],opening[2],opening[1]]:arc.slice().reverse();
        pocket.style.clipPath=polygon([[-400,-900],[740,-900],[740,foreground.at(-1)[1]],...foreground.slice().reverse(),[-400,foreground[0][1]]]);
        root.dataset.cardClearY=String(clearY);
        root.dataset.mouth=mouth.join(',');
        root.dataset.mouthShape=daily?'daily':rectangular?'rectangle':'ellipse';
        if(daily || rectangular) root.dataset.mouthOutline=JSON.stringify(opening);
        else delete root.dataset.mouthOutline;
      }
      const geometry=[selected,front.offsetLeft,front.offsetTop,front.offsetWidth,front.offsetHeight,style.transform,style.transformOrigin].join('|');
      if(geometry!==geometryKey) {
        const edge=[[front.offsetLeft,foreground[0][1]],...foreground,[front.offsetLeft+front.offsetWidth,foreground.at(-1)[1]]];
        const rimBottom=front.offsetTop+front.offsetHeight-baseLift;
        const rim=[...edge,[front.offsetLeft+front.offsetWidth,rimBottom],[front.offsetLeft,rimBottom]];
        const matrix=new DOMMatrix(style.transform);
        const [ox,oy]=style.transformOrigin.split(' ').map(Number.parseFloat);
        const left=front.offsetLeft+ox*(1-matrix.a)+matrix.e;
        const top=front.offsetTop+oy*(1-matrix.d)+matrix.f;
        front.style.clipPath=polygon(rim.map(([x,y])=>[(x-left)/matrix.a,(y-top)/matrix.d]));
        geometryKey=geometry;
      }
      const [cx,cy,rx,ry]=mouth;
      // Match the reference's bottom-centered 44% to 100% expansion while rising.
      const finalScale=targetCardWidth/((premium?224:width)*sceneScale);
      const initialScale=finalScale*.44;
      const lip=cy+ry,startBottom=lip+height*initialScale+14;
      const approvedEnd=daily?cy-58:['newyear','seollal','chuseok','hangul','christmas'].includes(root.dataset.holiday)?Math.min(408,cy-12):Math.min(410,cy-12);
      const endBottom=Math.min(approvedEnd,backLipY-9/sceneScale);
      root.dataset.cardApprovedBottom=String(approvedEnd);
      root.dataset.cardExtraLid=String(Math.max(0,height*finalScale-306));
      root.dataset.cardTarget=String(targetCardWidth);
      root.dataset.cardDisplayTarget=String(width*finalScale*sceneScale);
      root.dataset.cardTop=String(endBottom-height*finalScale);
      root.dataset.cardRestBottom=String(endBottom);
      const originalRest=daily?cy-58:['newyear','seollal','chuseok','hangul','christmas'].includes(root.dataset.holiday)?408:410;
      root.dataset.cardOriginalRest=String(originalRest);
      root.dataset.cardRestShift=String(Math.min(0,endBottom-originalRest));
      const bottom=startBottom+(endBottom-startBottom)*progress;
      // Expand only after the upper portion has cleared the opening.
      const expandStart=lip+height*initialScale*.4,expandEnd=cy-8;
      const expansion=smooth((expandStart-bottom)/(expandStart-expandEnd));
      const scale=initialScale+(finalScale-initialScale)*expansion;
      const finalX=ticket.offsetLeft+width/2;
      const center=cx+(finalX-cx)*smooth(progress);
      ticket.style.opacity=progress>0?'1':'0';
      ticket.style.transform=`translate(${center-finalX}px,${bottom-ticket.offsetTop-height+floatY}px) scale(${scale}) scaleX(${1/horizontalScale})`;
      root.dataset.cardScale=String(scale);root.dataset.cardBottom=String(bottom);
    };
  };
  return {prepare};
})();

  const initialize = root => {
    if (!root || root.dataset.ready === 'true') return;
    if (typeof root.showPopover !== 'function') root.removeAttribute('popover');
    const stage = root.querySelector('[data-coupon-stage]');
    const body = root.querySelector('[data-gift-body]');
    const lid = root.querySelector('.gift-lid');
    const seal = root.querySelector('.gift-seal');
    const ticket = root.querySelector('[data-coupon-ticket]');
    const renderCard = GiftMouth.prepare(root);
    const slides = [...root.querySelectorAll('[data-coupon-slide]')];
    const dots = [...root.querySelectorAll('[data-gift-dot]')];
    const pause = root.querySelector('[data-coupon-pause]');
    const toggle = root.querySelector('[data-gift-toggle]');
    const dismiss = root.querySelector('[data-coupon-dismiss]');
    const allOffers = root.querySelector('[data-coupon-open]');
    const modal = document.getElementById(slides[0]?.getAttribute('aria-controls'));
    if (!stage || !body || !lid || !seal || !slides.length || !modal) return;
    const mobile = matchMedia('(max-width:749px)');
    const wide = matchMedia('(min-width:1800px) and (min-height:720px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const finePointer = matchMedia('(hover:hover) and (pointer:fine)');
    const designer = root.dataset.designMode === 'true';
    const seasonConfig = {enabled:root.dataset.seasonEnabled==='true',mode:root.dataset.seasonMode,variant:root.dataset.seasonVariant,leadDays:Number(root.dataset.seasonLead),holidays:root.dataset.seasonHolidays.split(',').filter(Boolean)};
    const artworkReady = GiftSeasons.preload(root,GiftSeasons.resolve(seasonConfig));
    GiftSeasons.apply(root,seasonConfig);
    let nextSeasonCheck = Math.floor(Date.now()/30000)*30000+30000;
    let seasonSwapPending = false;
    let nextOverlayCheck = 0;
    const desktopSize = Math.max(.8,Math.min(1.1,Number(root.dataset.desktopSize)/100 || 1));
    const mobileSize = Math.max(.8,Math.min(1.1,Number(root.dataset.mobileSize)/100 || 1));
    const welcome = document.querySelector('dialog.signup-popup');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
    const save = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
    const prefix = 'cyfie-gift-cycle-';
    const visit = prefix + 'visit-v2-';
    const customer = root.dataset.customer || 'guest';
    if (read(visit + 'customer') && read(visit + 'customer') !== customer) {
      save(visit + 'closes', '0'); save(visit + 'until', '0'); save(visit + 'runtime-v3','');
    }
    save(visit + 'customer', customer);
    let closeCount = designer ? 0 : Math.min(2, Number(read(visit + 'closes')) || 0);
    let snoozeUntil = designer ? 0 : Number(read(visit + 'until')) || 0;
    let dockPosition = null;
    try { dockPosition = JSON.parse(read(visit + 'dock')); } catch {}
    if (!dockPosition || !['left','right'].includes(dockPosition.side) || !Number.isFinite(dockPosition.anchor)) dockPosition = null;
    const home = document.createComment('CYFIE gift home');
    root.before(home);
    let cartHost = null;
    let keyboardIntent = false;
    let idleShakeBand = 0;
    let arrival = Date.now();
    const modulo = (value, length) => ((value % length) + length) % length;
    const clamp = value => Math.max(0, Math.min(1, value));
    const smooth = value => { const p = clamp(value); return p * p * (3 - 2 * p); };
    const mix = (from, to, progress) => from + (to - from) * progress;
    const interval = Math.max(4500, Number(root.dataset.rotationMs) || 4500);
    const stageHeight = 640;
    const closedCut = 394;
    let cycle = 'waiting';
    let elapsed = 0;
    let layout = mobile.matches ? 'center' : 'featured';
    let placement = null;
    let placementMotion = null;
    let progressLid = 0;
    let progressPanel = 0;
    let returnPose = { lid: 1, panel: 1 };
    let phase = 0;
    let turn = null;
    let nextTurn = interval;
    const minimumExposure = Math.max(3000, interval - 420);
    let exposure = slides.map(() => 0);
    const offerSignature = slides.map(slide => slide.getAttribute('aria-label')).join('|');
    const allShown = () => exposure.every(time => time >= minimumExposure);
    const readRuntime = () => {
      try {
        const value = JSON.parse(read(visit + 'runtime-v3'));
        if (value?.version !== 3 || value.customer !== customer || value.offers !== offerSignature
          || !['waiting','dropping','opening','showing','retracting','shaking','closed','snoozed','dismissed'].includes(value.cycle)
          || !Number.isFinite(value.phase) || !Number.isFinite(value.elapsed) || value.elapsed < 0) return null;
        return value;
      } catch { return null; }
    };
    let manualPaused = false;
    let held = null;
    let suppressUntil = 0;
    let blocked = false;
    let assetsReady = false;
    let welcomeWasOpen = Boolean(welcome?.open);
    const welcomeGate = window.__cyfieSignupPopup;
    let welcomeClosed = designer || !welcome || ['closed','skipped'].includes(welcomeGate?.status);
    let disposed = false;
    let dismissed = closeCount >= 2;
    let lastTime = performance.now();
    let frame = null;
    let dropCount = 0;
    let openCount = 0;
    let shakeCount = 0;
    let geometryKey = '';
    let slideKey = '';
    const particles = [];
    const canvas = root.querySelector('[data-coupon-confetti]');
    const context = canvas?.getContext('2d');
    let burstCount = 0;
    let confettiTime = 0;
    const dimensions = () => {
      const viewport = visualViewport;
      const width = viewport?.width || innerWidth;
      const height = viewport?.height || innerHeight;
      const left = viewport?.offsetLeft || 0;
      const top = viewport?.offsetTop || 0;
      const header = Math.max(top, Math.min(top + height - 100, document.querySelector('.site-header')?.getBoundingClientRect().bottom || top));
      return { width, height, left, top, header };
    };
    // Painted alpha extents, in stage coordinates: base x/y/x/y, legacy-open
    // rotated lid x/y/x/y, measured rear lip, approved card bottom, old rest.
    // Shared Korean source images use the same open-art sizing in every skin.
    const giftInkBounds={
      'brand-1':[21.666667,415.123357,308.333333,641.158326,21.348,-75.614,308.005,59.613,418.226812,406.778636,406.778636],
      'newyear-1':[26.5,382.5,313,614,36.339,-95.674,308.278,81.039,388,393.25,408],
      'newyear-2':[26.5,382.5,313,614,36.339,-95.674,308.278,81.039,388,393.25,408],
      'newyear-3':[26.5,382.5,313,614,36.339,-95.674,308.278,81.039,388,393.25,408],
      'seollal-1':[26.5,382.5,313,614,36.339,-95.674,308.278,81.039,388,393.25,408],
      'seollal-2':[26.5,382.5,313,614,36.339,-95.674,308.278,81.039,388,393.25,408],
      'seollal-3':[26.5,382.5,313,614,36.339,-95.674,308.278,81.039,388,393.25,408],
      'children-1':[9.5,413.5,328.5,614,18.101,-93.529,326.518,105.586,416.5,410,410],
      'children-2':[9.5,413.5,328.5,614,18.101,-93.529,326.518,105.586,416.5,410,410],
      'children-3':[9.5,413.5,328.5,614,18.101,-93.529,326.518,105.586,416.5,410,410],
      'parents-1':[0,398,340,614,-6.13,-93.999,350.589,93.287,413,410,410],
      'parents-2':[0,398,340,614,-6.13,-93.999,350.589,93.287,413,410,410],
      'parents-3':[0,398,340,614,-6.13,-93.999,350.589,93.287,413,410,410],
      'chuseok-1':[1,364,338.5,600.5,38.216,-90.74,307.848,66.072,370.5,376,408],
      'chuseok-2':[1,364,338.5,600.5,38.216,-90.74,307.848,66.072,370.5,376,408],
      'chuseok-3':[1,364,338.5,600.5,38.216,-90.74,307.848,66.072,370.5,376,408],
      'hangul-1':[31.573,369.112,307.747,552.248,42.902,-99.228,300.517,42.288,370.796,382.366,408],
      'hangul-2':[31.573,369.112,307.747,552.248,42.902,-99.228,300.517,42.288,370.796,382.366,408],
      'hangul-3':[31.573,369.112,307.747,552.248,42.902,-99.228,300.517,42.288,370.796,382.366,408],
      'christmas-1':[37.144,355.452,302.298,603.86,47.576,-89.139,295.61,67.983,357.685,364.661,408],
      'christmas-2':[37.144,355.452,302.298,603.86,47.576,-89.139,295.61,67.983,357.685,364.661,408],
      'christmas-3':[37.144,355.452,302.298,603.86,47.576,-89.139,295.61,67.983,357.685,364.661,408],
      'valentine-1':[18.13,398.951,321.87,609.049,22.879,-71.238,320.175,96.24,422,410,410],
      'valentine-2':[8.438,429.741,330.603,608.082,23.473,-87.162,321.024,96.953,451,410,410],
      'valentine-3':[20.748,398.896,317.907,608.207,21.499,-73.709,318.638,96.081,416,410,410],
      'blackfriday-1':[8.246,434.334,330.924,608.339,24.373,-42.642,322.192,99.737,443,410,410],
      'blackfriday-2':[11.378,398.504,327.615,605.972,23.005,-86.157,319.568,96.829,411,410,410],
      'blackfriday-3':[23.079,399.479,315.935,610,22.868,-87.497,320.323,97.5,415,410,410]
    };
    const svgGiftInk=[36.667,414,323.333,607,-10.333,-98,362.667,41,420.944,410,410];
    const premiumGiftInk=[21.667,415.123,308.333,641.158,21.348,-75.614,308.005,59.613,420.944,410,410];
    const dailyReferenceInk=[8.6,428.8,331.8,603.6,6.215,-18.969,332.538,78.048,431.2,409.2,409.2];
    let compositionKey='',compositionValue;
    const composition=()=>{
      const view=dimensions(),daily=root.dataset.holiday==='brand',premium=root.dataset.premiumBox==='true';
      const ink=premium?premiumGiftInk:giftInkBounds[`${root.dataset.holiday}-${root.dataset.skin}`]||(daily?giftInkBounds['brand-1']:svgGiftInk);
      const referenceInk=daily?dailyReferenceInk:premium?svgGiftInk:ink;
      const key=[view.width,view.height,view.left,view.top,view.header,mobile.matches,root.dataset.holiday,root.dataset.skin,premium,premium?dockPosition?.anchor:'',root.dataset.cardBackLip,root.dataset.cardApprovedBottom,root.dataset.cardOriginalRest,desktopSize,mobileSize].join('|');
      if(key===compositionKey) return compositionValue;
      const readGeometry=(name,fallback)=>{const value=Number(root.dataset[name]);return Number.isFinite(value)?value:fallback;};
      const sourceBack=premium?referenceInk[8]:readGeometry('cardBackLip',ink[8]);
      const approved=premium?referenceInk[9]:readGeometry('cardApprovedBottom',ink[9]);
      const originalRest=premium?referenceInk[10]:readGeometry('cardOriginalRest',ink[10]);
      const availableWidth=Math.max(1,view.width-24);
      const availableHeight=Math.max(1,view.top+view.height-12-(view.header+12));
      const wantedBody=(mobile.matches?194:170)*(mobile.matches?mobileSize/.85:desktopSize/.95);
      const rawBodyWidth=Math.max(1,referenceInk[2]-referenceInk[0]);
      const preferredScale=Math.min(1.15,wantedBody/rawBodyWidth+(daily?14/325.2:0));
      const preferredCard=Math.min((mobile.matches?144:126)*(premium?1.05:1),Math.max(96,view.width-60));
      const envelope=(scale,cardWidth,artInk=referenceInk)=>{
        const legacyDaily=daily&&artInk===dailyReferenceInk;
        const horizontalScale=legacyDaily?Math.max(.25,1-14/(325.2*scale)):1;
        const x=value=>(170+(value-170)*horizontalScale)*scale;
        const baseLift=legacyDaily?Math.min(2*96/25.4,Math.max(0,17*scale-3))/scale:0;
        const back=legacyDaily?431.2-baseLift:premium&&artInk===premiumGiftInk?premiumGiftInk[8]:sourceBack;
        const end=Math.min(legacyDaily?dailyReferenceInk[9]:approved,back-9/scale);
        const finalScale=cardWidth/(224*scale);
        const cardHeight=premium&&artInk===premiumGiftInk?332:316;
        const extra=Math.max(0,cardHeight*finalScale-306);
        const lidShift=end-cardHeight*finalScale-8/scale-artInk[7];
        const cardDisplayWidth=cardWidth*(premium?1.09:1);
        const cardLeft=x(165)-cardDisplayWidth/2,cardRight=cardLeft+cardDisplayWidth;
        const cardTop=(end-cardHeight*finalScale)*scale,cardBottom=end*scale;
        const baseBottom=artInk[3]-baseLift;
        const left=Math.min(x(artInk[0]),x(artInk[4]),cardLeft,0)-3;
        const right=Math.max(x(artInk[2]),x(artInk[6]),cardRight+18,340*scale)+3;
        const top=Math.min((artInk[1]-baseLift)*scale,(artInk[5]+lidShift)*scale,cardTop-18)-3;
        const bottom=Math.max(baseBottom*scale+40,(artInk[7]+lidShift)*scale,cardBottom+3*scale)+3;
        return {scale,cardWidth,cardDisplayWidth,cardCenterPx:x(165),finalScale,baseBottom,baseBottomPx:baseBottom*scale,baseCenter:(artInk[0]+artInk[2])/2,
          backLip:back,restBottom:end,extraLidRaise:extra,lidLegacyBottom:artInk[7],lidShift,cardTop,cardBottom,
          headroom:Math.max(0,-top/scale),headroomPx:Math.max(0,-top),
          bounds:{left,top,right,bottom,width:right-left,height:bottom-top},
          allLink:{left:0,width:340*scale,top:baseBottom*scale+8,height:32}};
      };
      const fits=value=>value.bounds.width<=availableWidth+.01&&value.bounds.height<=availableHeight+.01;
      // Keep the card and painted box in the same proportion on short screens.
      const minimumFactor=Math.min(1,110/preferredCard);
      const scaledEnvelope=factor=>envelope(preferredScale*factor,preferredCard*factor);
      let lower=minimumFactor,upper=1;
      if(fits(scaledEnvelope(upper))) lower=upper;
      else if(fits(scaledEnvelope(lower))) for(let i=0;i<18;i++){const middle=(lower+upper)/2;if(fits(scaledEnvelope(middle))) lower=middle;else upper=middle;}
      const fitted=scaledEnvelope(lower);
      // Reduce only the artwork; preserve the approved card size and its fitted placement.
      const artworkScale=daily?Math.min(1.15,wantedBody/(ink[2]-ink[0]))*(fitted.cardWidth/preferredCard)*.8836:fitted.scale*(premium?.8836:.94);
      let resized=envelope(artworkScale,fitted.cardWidth,ink);
      let fitsResized=fits;
      if(premium||daily){
        // Check the actual viewport after pinning the card to its approved position.
        const minTop=view.header+12-fitted.bounds.top,maxTop=view.top+view.height-12-fitted.bounds.bottom;
        const legacyTop=mobile.matches
          ? minTop+(availableHeight-fitted.bounds.height)/2
          : (dockPosition?view.top+dockPosition.anchor*view.height:view.top+view.height-74)-fitted.bounds.bottom;
        const referenceTop=minTop>maxTop?(minTop+maxTop)/2:Math.max(minTop,Math.min(maxTop,legacyTop));
        const referenceCardY=referenceTop+fitted.cardTop-(premium?16*fitted.cardWidth/224:0);
        fitsResized=value=>fits(value)
          && referenceCardY+value.bounds.top-value.cardTop>=view.header+12-.01
          && referenceCardY+value.bounds.bottom-value.cardTop<=view.top+view.height-12+.01;
      }
      if((premium||daily) && fits(fitted) && !fitsResized(resized)){
        // A deeper gift still fits ordinary short phones without enlarging or moving the card.
        let lower=Math.min(artworkScale,fitted.cardWidth*(daily?.9:1.08)/(ink[2]-ink[0])),upper=artworkScale;
        if(fitsResized(envelope(lower,fitted.cardWidth,ink))){
          for(let i=0;i<18;i++){const middle=(lower+upper)/2;if(fitsResized(envelope(middle,fitted.cardWidth,ink))) lower=middle;else upper=middle;}
          resized=envelope(lower,fitted.cardWidth,ink);
        }
      }
      compositionValue={...resized,reference:fitted,fits:fits(fitted)&&fitsResized(resized),availableWidth,availableHeight,preferredScale};
      compositionKey=key;
      return compositionValue;
    };
    const targetPlacement = kind => {
      const view=dimensions();
      const constrain=(value,minimum,maximum)=>minimum>maximum?(minimum+maximum)/2:Math.max(minimum,Math.min(maximum,value));
      if(kind==='dock'){
        const scale=(mobile.matches?.28:.40)*(mobile.matches?mobileSize:desktopSize)*(root.dataset.premiumBox==='true'||root.dataset.holiday==='brand'?.92:1);
        const width=340*scale,closedHeight=(stageHeight-closedCut)*scale;
        const defaultAnchor=view.top+view.height-(mobile.matches?76:74);
        const anchor=dockPosition?view.top+dockPosition.anchor*view.height:defaultAnchor;
        const ordinaryLeft=wide.matches?Math.max(12,(view.width-1360)/4-width/2):14;
        const left=dockPosition?.side==='right'?view.left+view.width-width-14:view.left+ordinaryLeft;
        return {scale,left:constrain(left,view.left+12,view.left+view.width-width-12),anchor:constrain(anchor,view.header+12+closedHeight,view.top+view.height-12)};
      }
      const metrics=composition(),reference=metrics.reference||metrics,scale=reference.scale,bounds=reference.bounds;
      const minLeft=view.left+12-bounds.left,maxLeft=view.left+view.width-12-bounds.right;
      const minTop=view.header+12-bounds.top,maxTop=view.top+view.height-12-bounds.bottom;
      let left,top;
      if(mobile.matches){
        left=view.left+(view.width-bounds.width)/2-bounds.left;
        top=view.header+12+(metrics.availableHeight-bounds.height)/2-bounds.top;
      }else{
        left=wide.matches?view.left+Math.max(12,(view.width-1360)/4-340*scale/2):view.left+12;
        if(dockPosition?.side==='right') left=maxLeft;
        const bottom=dockPosition?view.top+dockPosition.anchor*view.height:view.top+view.height-74;
        top=bottom-bounds.bottom;
      }
      const fullStageTop=constrain(top,minTop,maxTop);
      const cardShiftX=reference.cardCenterPx-metrics.cardCenterPx;
      const cardShiftY=reference.cardTop-metrics.cardTop-(root.dataset.premiumBox==='true'?16*metrics.cardWidth/224:0);
      return {scale:metrics.scale,left:constrain(left,minLeft,maxLeft)+cardShiftX,anchor:fullStageTop+cardShiftY+stageHeight*metrics.scale};
    };
    const place = (kind, animate = true) => {
      const target = targetPlacement(kind);
      layout = kind;
      root.dataset.layout = kind;
      toggle.setAttribute('aria-expanded', String(kind !== 'dock'));
      if (!placement || !animate || reduced.matches) { placement = target; placementMotion = null; }
      else placementMotion = { from: { ...placement }, to: target, time: 0, duration: 720 };
      lastTime = performance.now();
    };
    const selectCycle = next => {
      cycle = next;
      elapsed = 0;
      root.dataset.cycle = next;
      root.dataset.state = ['waiting','snoozed','dismissed'].includes(next) ? next : layout === 'dock' ? 'docked' : mobile.matches ? 'center' : 'desktop';
      if (next === 'dropping') { dropCount += 1; root.dataset.startedAt = String(performance.now()); }
      if (next === 'opening') { openCount += 1; root.dataset.openedAt = String(performance.now()); burst(); }
      if (next === 'showing') { root.dataset.showingAt = String(performance.now()); nextTurn = interval; exposure = slides.map(() => 0); }
      if (next === 'shaking') shakeCount += 1;
      if (next === 'closed') { root.dataset.closedAt = String(performance.now()); idleShakeBand = 0; }
    };
    const keyboardPaused = () => cycle === 'showing' && keyboardIntent && root.contains(document.activeElement) && document.activeElement?.matches(':focus-visible') && document.activeElement !== pause;
    // Finish a requested turn before pausing, so a card never freezes edge-on.
    const frozen = () => blocked || modal.open || Boolean(held) || (!turn && (manualPaused || keyboardPaused() || (cycle==='showing' && finePointer.matches && root.dataset.hovered==='true')));
    const paintSlides = () => {
      const current = modulo(Math.round(phase), slides.length);
      const key = `${phase.toFixed(5)}|${cycle}|${layout}|${mobile.matches}`;
      if (key === slideKey) return;
      slideKey = key;
      slides.forEach((slide, index) => {
        const offset = modulo(phase - index + slides.length / 2, slides.length) - slides.length / 2;
        const angle = Math.max(-1, Math.min(1, offset)) * Math.PI / 2;
        const radius = ticket.clientWidth / 2;
        slide.style.transform = `translate3d(${-radius * Math.sin(angle)}px,0,${radius * (Math.cos(angle) - 1)}px) rotateY(${-offset * 90}deg)`;
        slide.style.opacity = String(clamp((1 - Math.abs(offset)) / .18));
        slide.style.setProperty('--turn-shade', String(Math.min(1, Math.abs(offset)) * .35));
        slide.classList.toggle('is-current', current === index);
        slide.setAttribute('aria-hidden', String(index !== current || cycle !== 'showing'));
        slide.tabIndex = current === index && cycle === 'showing' && !(mobile.matches && layout === 'dock') ? 0 : -1;
      });
      dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(current === index)));
      root.querySelector('[data-coupon-position]').textContent = String(current + 1);
      root.dataset.current = String(current);
    };
    const navigate = steps => {
      if (cycle !== 'showing') return;
      const target = Math.round(phase) + steps;
      if (reduced.matches) { phase = target; turn = null; }
      else turn = { from: phase, to: target, time: 0, duration: 420 };
      nextTurn = interval;
      paintSlides();
    };
    const advanceCarousel = delta => {
      if (cycle !== 'showing' || frozen()) return;
      let stableTime = delta;
      if (turn) {
        stableTime = Math.max(0, delta - (turn.duration - turn.time));
        turn.time = Math.min(turn.duration, turn.time + delta);
        phase = mix(turn.from, turn.to, smooth(turn.time / turn.duration));
        if (turn.time >= turn.duration) { phase = turn.to; turn = null; }
      }
      if (!turn && Math.abs(phase - Math.round(phase)) < .001) {
        const current = modulo(Math.round(phase), slides.length);
        exposure[current] = Math.min(minimumExposure, exposure[current] + stableTime);
      }
      if (designer && allShown()) exposure=slides.map(()=>0);
      if (reduced.matches || allShown()) return;
      nextTurn -= delta;
      if (nextTurn <= 0 && !turn && exposure[modulo(Math.round(phase), slides.length)] >= minimumExposure) { navigate(1); nextTurn = interval; }
    };
    const burst = () => {
      if (!context || reduced.matches || designer || root.dataset.confettiEnabled !== 'true') return;
      burstCount += 1;
      const dpr = Math.min(devicePixelRatio || 1, 2);
      canvas.width = 460 * dpr; canvas.height = 820 * dpr;
      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      const colors = ['#dcb568', '#f3deb1', '#06704b', '#e8c48c'];
      particles.length=0;
      const count=mobile.matches?40:60;
      const mouth=(root.dataset.mouth||'170,440,110,20').split(',').map(Number);
      for(let index=0;index<count;index+=1){
        particles.push({source:'bottom',x:mouth[0]+(Math.random()-.5)*mouth[2],y:mouth[1]-8,
          vx:(Math.random()-.5)*220,vy:-(180+Math.random()*180),gravity:300,
          color:colors[index%colors.length],width:2.5,length:index%7?6:16,ribbon:index%7===0,
          spin:(Math.random()-.5)*5,seed:Math.random()*6,born:Math.random()*120,life:1500+Math.random()*400});
      }
      confettiTime = 0;
    };
    const paintConfetti = delta => {
      if (!context || !particles.length) return;
      if (blocked || reduced.matches) { particles.length = 0; context.clearRect(0, 0, 460, 820); return; }
      confettiTime += delta;
      context.clearRect(0, 0, 460, 820);
      for (let index = particles.length - 1; index >= 0; index -= 1) {
        const p = particles[index];
        const age = confettiTime - p.born;
        if (age > p.life) { particles.splice(index, 1); continue; }
        if (age < 0) continue;
        const dt = Math.min(.045, delta / 1000);
        p.vy += p.gravity * dt; p.vx *= Math.exp(-.6 * dt);
        p.x += p.vx * dt; p.y += p.vy * dt;
        context.save(); context.translate(p.x + 60, p.y + 340); context.rotate(age / 1000 * p.spin);
        context.globalAlpha = clamp((p.life - age) / 550); context.fillStyle = p.color; context.strokeStyle = p.color;
        if (p.ribbon) { context.beginPath(); for (let n = 0; n <= 12; n += 1) { const x = Math.sin(n * .85 + age / 250 + p.seed) * 4; const y = (n / 12 - .5) * p.length; if (n === 0) context.moveTo(x, y); else context.lineTo(x, y); } context.lineWidth = p.width; context.stroke(); }
        else context.fillRect(-p.width / 2, -p.length / 2, p.width, p.length);
        context.restore();
      }
      root.dataset.confettiActive=String(particles.length);root.dataset.confettiTop=String(particles.filter(p=>p.source==='top').length);root.dataset.confettiBottom=String(particles.filter(p=>p.source==='bottom').length);
    };
    const beginReturn = () => {
      if (['waiting','dismissed','retracting','shaking','closed'].includes(cycle)) return;
      returnPose = { lid: progressLid, panel: progressPanel };
      selectCycle('retracting');
      lastTime = performance.now();
    };
    const duration = () => {
      if (reduced.matches) return cycle === 'showing' || cycle === 'closed' ? Infinity : 0;
      return ({ dropping: 1100, opening: 1150, showing: Infinity, retracting: 1050, shaking: 650, closed: composition().fits?30000:Infinity })[cycle] ?? Infinity;
    };
    const finishChapter = () => {
      if (cycle === 'dropping') {
        if(composition().fits) { if(layout==='dock') place(mobile.matches ? 'center' : 'featured'); selectCycle('opening'); }
        else {place('dock',false);selectCycle('closed');}
      }
      else if (cycle === 'opening') selectCycle('showing');
      else if (cycle === 'showing') { returnPose = { lid: 1, panel: 1 }; selectCycle('retracting'); }
      else if (cycle === 'retracting') { place('dock'); selectCycle('shaking'); }
      else if (cycle === 'shaking') selectCycle('closed');
      else if (cycle === 'closed') { if (layout === 'dock') place(mobile.matches ? 'center' : 'featured'); selectCycle('opening'); }
    };
    const advanceCycle = delta => {
      let remaining = delta;
      for (let attempts = 0; attempts < 12; attempts += 1) {
        const length = duration();
        const portion = Math.min(remaining, Math.max(0, length - elapsed));
        advanceCarousel(portion);
        elapsed += portion; remaining -= portion;
        if (cycle === 'showing' && allShown() && !turn && !designer) { finishChapter(); break; }
        if (elapsed < length || !Number.isFinite(length)) break;
        finishChapter();
        if (placementMotion || remaining <= 0 && duration() > 0) break;
      }
    };
    const render = () => {
      const metrics=composition();
      let dropY = 0, dropAngle = 0, shakeX = 0, shakeAngle = 0;
      if (cycle === 'opening') { progressLid = reduced.matches ? 1 : smooth(elapsed / 850); progressPanel = reduced.matches ? 1 : smooth((elapsed - 380) / 750); }
      else if (cycle === 'showing') { progressLid = 1; progressPanel = 1; }
      else if (cycle === 'retracting') { progressLid = returnPose.lid * (1 - smooth((elapsed - 350) / 700)); progressPanel = returnPose.panel * (1 - smooth(elapsed / 600)); }
      else { progressLid = 0; progressPanel = 0; }
      if (cycle === 'dropping') {
        const progress = clamp(elapsed / 1100);
        if (progress < .72) { const p = progress / .72; dropY = -(innerHeight / placement.scale + stageHeight) * (1 - p * p); dropAngle = -6 * (1 - p); }
        else if (progress < .9) { const p = (progress - .72) / .18; dropY = -23 * Math.sin(p * Math.PI); dropAngle = Math.sin(p * Math.PI) * 1.6; }
        root.dataset.dropProgress = String(progress);
      }
      const idleBand = Math.floor(elapsed / 5000);
      const idleTime = elapsed % 5000;
      const idleShake = cycle === 'closed' && idleBand > 0 && idleTime < 650;
      if (cycle === 'closed' && !reduced.matches && idleBand > idleShakeBand) { shakeCount += idleBand - idleShakeBand; idleShakeBand = idleBand; }
      const shaking = cycle === 'shaking' || idleShake;
      if (shaking && !reduced.matches) { const p = clamp((idleShake ? idleTime : elapsed) / 650); const wave = Math.sin(p * Math.PI * 8) * (1 - p) ** 2; shakeX = wave * 4 / placement.scale; shakeAngle = wave * 4; }
      root.dataset.shaking = String(shaking && !reduced.matches);
      const sealOpacity = smooth((.24 - progressLid) / .24);
      const horizontalScale = 1;
      const verticalScale = 1;
      body.style.transform = `translate(${shakeX}px,${dropY}px) scaleX(${horizontalScale}) scaleY(${verticalScale}) rotate(${dropAngle + shakeAngle}deg)`;
      root.dataset.shellHorizontalScale = String(horizontalScale);
      root.dataset.shellWidthReduction = '0';
      root.dataset.shellVerticalScale = String(verticalScale);
      root.dataset.shellHeightReduction = '0';
      body.style.filter = cycle === 'shaking' ? `drop-shadow(0 0 ${10 * (1 - elapsed / 650)}px #58ad0850)` : 'none';
      seal.style.opacity = String(sealOpacity);
      root.style.setProperty('--gift-shell-open', String(1-sealOpacity));
      lid.style.opacity = String(1 - sealOpacity);
      const floatY = cycle === 'showing' && !reduced.matches ? Math.sin(elapsed / 1200) * 2 : 0;
      const baseLiftPixels = 0;
      const baseLift = baseLiftPixels / placement.scale;
      root.style.setProperty('--gift-base-shift', `${-baseLift}px`);
      root.dataset.baseLiftStage = String(baseLift);
      root.dataset.baseLiftPixels = String(baseLiftPixels);
      renderCard(ticket,progressPanel,floatY,horizontalScale,baseLift,placement.scale,metrics.cardWidth);
      const lidShift=Number(root.dataset.cardTop)-8/placement.scale-metrics.lidLegacyBottom;
      const lidOpenY=-98+lidShift;
      root.dataset.lidClearanceRaise=String(-lidShift);
      lid.style.transform = `translateY(${mix(335, lidOpenY, progressLid)}px) rotate(${mix(8, -2, progressLid)}deg)`;
      root.style.setProperty('--gift-panel', String(progressPanel));
      root.style.setProperty('--gift-shadow-scale', String(1 - floatY / 60));
      const cut = closedCut * (1 - Math.max(progressLid, progressPanel));
      if (mobile.matches && layout === 'center' && !placementMotion) placement.anchor = targetPlacement('center').anchor;
      const width = 340 * placement.scale;
      const height = (stageHeight - cut) * placement.scale;
      const top = placement.anchor - height;
      const key = [width,height,top,placement.left,cut].map(n => n.toFixed(3)).join('|');
      if (key !== geometryKey) {
        geometryKey = key;
        root.style.setProperty('--gift-left', `${placement.left}px`); root.style.setProperty('--gift-top', `${top}px`);
        root.style.setProperty('--gift-width', `${width}px`); root.style.setProperty('--gift-height', `${height}px`);
        root.style.setProperty('--gift-scale', String(placement.scale)); root.style.setProperty('--gift-offset', `${-cut * placement.scale}px`);
      }
      const uiScale=metrics.cardWidth/224;
      root.style.setProperty('--gift-card-font',`${Math.max(18,11/uiScale)}px`);
      root.style.setProperty('--gift-card-line',`${Math.max(21,13/uiScale)}px`);
      root.style.setProperty('--gift-card-cta-font',`${Math.max(16,10/uiScale)}px`);
      root.style.setProperty('--gift-card-cta-line',`${Math.max(18,12/uiScale)}px`);
      root.style.setProperty('--gift-card-badge-font',`${Math.max(14,8.5/uiScale)}px`);
      root.style.setProperty('--gift-card-badge-line',`${Math.max(18,11/uiScale)}px`);
      root.style.setProperty('--gift-card-footer',`${Math.max(48,28/uiScale)}px`);
      root.style.setProperty('--gift-card-control',`${Math.max(40,24/uiScale)}px`);
      root.style.setProperty('--gift-card-counter-font',`${Math.max(13,8.5/uiScale)}px`);
      root.style.setProperty('--gift-all-font',`${11/placement.scale}px`);
      root.style.setProperty('--gift-all-line',`${14/placement.scale}px`);
      root.style.setProperty('--gift-all-height',`${32/placement.scale}px`);
      if(allOffers) allOffers.style.top=`${metrics.baseBottom+8/placement.scale}px`;
      root.dataset.compactCard=String(metrics.cardWidth<124);
      root.dataset.compositionFits=String(metrics.fits);
      root.dataset.compositionBounds=JSON.stringify(metrics.bounds);
      if(layout!=='dock'){
        const fullScale=metrics.cardWidth/(224*placement.scale),cx=170+(165-170)*horizontalScale;
        dismiss.style.left=(cx*placement.scale+metrics.cardDisplayWidth/2-12)+'px';
        dismiss.style.top=((Number(root.dataset.cardRestBottom||410)-ticket.offsetHeight*fullScale)*placement.scale-16)+'px';
        dismiss.style.right='auto';
      }else {dismiss.style.removeProperty('left');dismiss.style.removeProperty('top');dismiss.style.removeProperty('right');}
      root.dataset.layout = layout;
      root.dataset.state = ['waiting','snoozed','dismissed'].includes(cycle) ? cycle : dismissed ? 'dismissed' : layout === 'dock' ? 'docked' : mobile.matches ? 'center' : 'desktop';
      root.dataset.cycle = cycle; root.dataset.cycleElapsed = String(elapsed); root.dataset.lidProgress = String(progressLid); root.dataset.panelProgress = String(progressPanel);
      root.dataset.offersSeen = String(exposure.filter(time => time >= minimumExposure).length); root.dataset.offersTotal = String(slides.length); root.dataset.exposure = JSON.stringify(exposure);
      root.dataset.phase = String(phase); root.dataset.displayedPhase = String(phase); root.dataset.moving = String(Boolean(turn));
      root.dataset.closeWait = String(cycle === 'closed' ? 30000 - elapsed : 0);
      root.dataset.openCount = String(openCount); root.dataset.dropCount = String(dropCount); root.dataset.shakes = String(shakeCount); root.dataset.bursts = String(burstCount);
      root.dataset.confettiActive=String(particles.length);
      root.dataset.placing = String(Boolean(placementMotion)); root.dataset.held = String(Boolean(held));
      pause.setAttribute('aria-pressed', String(manualPaused || reduced.matches)); pause.setAttribute('aria-label', manualPaused || reduced.matches ? pause.dataset.playLabel : pause.dataset.pauseLabel);
      const sealed = cycle === 'closed' || cycle === 'shaking';
      dismiss.setAttribute('aria-label', sealed ? closeCount ? 'Hide gift offers for this visit' : 'Hide gift offers for 5 minutes' : dismiss.dataset.minimizeLabel);
      dismiss.title = dismiss.getAttribute('aria-label');
      root.dataset.closeCount = String(closeCount); root.dataset.snoozeUntil = String(snoozeUntil);
      root.dataset.dockSide = dockPosition?.side || 'left';
      paintSlides();
    };
    // A modal cart makes the page inert. Keep the gift inside that modal, and
    // use the browser's top layer so the drawer cannot clip the floating gift.
    const syncCartLayer = () => {
      const cart = document.querySelector('dialog[data-cart-drawer][open]');
      const visible = !blocked && !dismissed && !['waiting','snoozed'].includes(cycle) && !modal.open;
      if (cartHost !== cart) {
        if (root.hasAttribute('popover')) {
          if (root.matches(':popover-open')) root.hidePopover();
          root.removeAttribute('popover');
        }
        cartHost = cart;
        if (cart) { cart.append(root); if (typeof root.showPopover === 'function') root.setAttribute('popover','manual'); }
        else if (home.isConnected) home.after(root);
      }
      if (root.hasAttribute('popover')) {
        if (visible && !root.matches(':popover-open')) root.showPopover();
        else if (!visible && root.matches(':popover-open')) root.hidePopover();
      }
      root.dataset.inCart = String(Boolean(cart));
    };
    const shopifyFormsOpen = () => {
      const shadow = document.querySelector('shopify-forms-embed')?.shadowRoot;
      if (!shadow) return false;
      return [...shadow.querySelectorAll('[role="dialog"]')].some(dialog => {
        const bounds = dialog.getBoundingClientRect();
        const style = getComputedStyle(dialog);
        return bounds.width > 1 && bounds.height > 1 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0 && style.pointerEvents !== 'none';
      });
    };
    const availability = () => {
      if (welcome?.open) welcomeWasOpen = true;
      else if (welcomeWasOpen) welcomeClosed = true;
      const previous = blocked;
      const formsOpen = shopifyFormsOpen();
      root.dataset.formsBlocked = String(formsOpen);
      blocked = !welcomeClosed || formsOpen || document.hidden || [...document.querySelectorAll('dialog[open]')].some(dialog => dialog !== modal && !(designer && dialog===welcome) && !dialog.matches('[data-cart-drawer]')) || Boolean(document.querySelector('.mobile-nav[open]'));
      root.dataset.blocked = String(blocked);
      root.inert = blocked || dismissed || ['waiting','snoozed'].includes(cycle);
      syncCartLayer();
      if (previous !== blocked) lastTime = performance.now();
    };
    const releaseWelcomeGate = () => {
      if (welcomeClosed) return;
      welcomeClosed = true;
      welcomeWasOpen = true;
      arrival = Date.now() - 3500;
      availability();
    };
    const restoreSnoozed = () => {
      snoozeUntil = 0; save(visit + 'until','0');
      manualPaused = false; held = null; turn = null;
      progressLid = 0; progressPanel = 0;
      place('dock',false); selectCycle('closed'); availability(); render();
    };
    const safeSeasonSwap = () => !held && !modal.open && !placementMotion && ['waiting','closed','snoozed','dismissed'].includes(cycle);
    const refreshSeason = async () => {
      if(disposed || seasonSwapPending)return;
      const next=GiftSeasons.resolve(seasonConfig);
      if(next.holiday===root.dataset.holiday && String(next.variant)===root.dataset.skin){GiftSeasons.apply(root,seasonConfig);return;}
      if(!safeSeasonSwap())return;
      seasonSwapPending=true;
      try{
        // Decode the next sculpted skin before atomically replacing the four frames.
        const url=GiftSeasons.assetUrl(root,next);
        await GiftSeasons.preload(root,next);
        if(!disposed && safeSeasonSwap() && GiftSeasons.assetUrl(root,GiftSeasons.resolve(seasonConfig))===url)GiftSeasons.apply(root,seasonConfig);
      }catch{/* Keep the current gift when a replacement asset cannot load. */}
      finally{seasonSwapPending=false;}
    };
    const tick = now => {
      if (disposed) return;
      const delta = Math.max(0, now - lastTime); lastTime = now;
      if (now >= nextOverlayCheck) { nextOverlayCheck = now + 250; availability(); }
      if(Date.now()>=nextSeasonCheck){nextSeasonCheck=Math.floor(Date.now()/30000)*30000+30000;refreshSeason();}
      if (cycle === 'snoozed' && Date.now() >= snoozeUntil && !dismissed) restoreSnoozed();
      if (!dismissed && cycle !== 'snoozed' && assetsReady) {
        if (cycle === 'waiting' && !blocked && welcomeClosed && Date.now() - arrival >= 3500) {
          place(composition().fits?(mobile.matches ? 'center' : 'featured'):'dock', false); selectCycle(designer&&composition().fits?'opening':'dropping'); root.inert = false;
        }
        if (placementMotion && !blocked && !modal.open && !held) {
          if (placementMotion.openOnMove && !frozen()) {
            advanceCycle(delta);
            placementMotion.to = targetPlacement(layout);
          }
          placementMotion.time += delta;
          const p = smooth(placementMotion.time / placementMotion.duration);
          placement = { scale: mix(placementMotion.from.scale,placementMotion.to.scale,p), left: mix(placementMotion.from.left,placementMotion.to.left,p), anchor: mix(placementMotion.from.anchor,placementMotion.to.anchor,p) };
          if (placementMotion.time >= placementMotion.duration) { placement = placementMotion.to; placementMotion = null; }
        } else if (cycle !== 'waiting' && !frozen() && !placementMotion) advanceCycle(delta);
        render(); paintConfetti(delta); syncCartLayer();
      }
      frame = requestAnimationFrame(tick);
    };
    const expand = () => {
      if (dismissed || blocked || cycle === 'snoozed' || layout !== 'dock') return;
      if(!composition().fits){openPanel();return;}
      root.dataset.expandPhase = String(phase); root.dataset.expandCycle = cycle; root.dataset.expandElapsed = String(elapsed);
      const closed = cycle === 'closed' || cycle === 'shaking';
      if (closed) { manualPaused = false; selectCycle('opening'); }
      place(mobile.matches ? 'center' : 'featured');
      if (closed && placementMotion) placementMotion.openOnMove = true;
      render();
    };
    const openPanel = index => {
      if (dismissed || blocked || ['waiting','snoozed'].includes(cycle)) return;
      modal.querySelectorAll('[data-coupon-offer]').forEach((offer, n) => offer.dataset.selected = String(n === modulo(index ?? Math.round(phase), slides.length)));
      if (!modal.open) modal.showModal(); lastTime = performance.now();
    };
    const allowClick = event => event.detail === 0 || Date.now() >= suppressUntil;
    root.addEventListener('click', event => {
      if (!allowClick(event)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (layout === 'dock' && !event.target.closest('[data-coupon-dismiss]')) { event.preventDefault(); event.stopImmediatePropagation(); expand(); }
    }, { ...options, capture: true });
    slides.forEach((slide,index) => slide.addEventListener('click', () => openPanel(index), options));
    toggle.addEventListener('click', () => {
      if (layout === 'dock') expand();
      else if (cycle === 'closed' || cycle === 'shaking') { manualPaused = false; selectCycle('opening'); render(); }
      else openPanel();
    }, options);
    root.querySelector('[data-coupon-open]').addEventListener('click', () => openPanel(), options);
    dots.forEach((dot,index) => dot.addEventListener('click', () => navigate(modulo(index - Math.round(phase) + slides.length / 2, slides.length) - slides.length / 2), options));
    root.querySelector('[data-coupon-next]').addEventListener('click', () => navigate(1), options);
    root.querySelector('[data-coupon-previous]').addEventListener('click', () => navigate(-1), options);
    pause.addEventListener('click', () => { manualPaused = !manualPaused; lastTime = performance.now(); render(); }, options);
    dismiss.addEventListener('click', () => {
      if (cycle !== 'closed' && cycle !== 'shaking') {
        manualPaused = false; keyboardIntent = false;
        if (root.contains(document.activeElement)) document.activeElement.blur();
        beginReturn(); render(); return;
      }
      closeCount = Math.min(2, closeCount + 1); save(visit + 'closes',String(closeCount));
      snoozeUntil = closeCount === 1 ? Date.now() + 300000 : 0; save(visit + 'until',String(snoozeUntil));
      dismissed = closeCount >= 2; manualPaused = false; turn = null;
      selectCycle(dismissed ? 'dismissed' : 'snoozed');
      if (root.contains(document.activeElement)) document.activeElement.blur();
      availability(); render();
    }, options);
    root.addEventListener('pointerdown', event => {
      if (event.button !== 0 || held || dismissed || blocked || ['waiting','snoozed'].includes(cycle) || event.target.closest('[data-coupon-dismiss],[data-coupon-open],.gift-dot,.coupon-offers__control')) return;
      const element = event.target.closest('button') || root;
      held = { id: event.pointerId, x: event.clientX, y: event.clientY, phase, began: performance.now(), moved: false, element, mode: mobile.matches && layout === 'dock' ? 'dock' : 'carousel', placement: { ...placement }, cycle };
      keyboardIntent = false;
      element.setPointerCapture(event.pointerId); lastTime = performance.now(); render();
    }, options);
    root.addEventListener('pointermove', event => {
      if (!held || held.id !== event.pointerId) return;
      const distance = event.clientX - held.x;
      if (held.mode === 'dock') {
        const dy = event.clientY - held.y;
        if (!held.moved && Math.hypot(distance,dy) < 7) return;
        held.moved = true; event.preventDefault(); placementMotion = null;
        const view = dimensions();
        placement.left = Math.max(view.left + 14, Math.min(view.left + view.width - 340 * placement.scale - 14, held.placement.left + distance));
        placement.anchor = Math.max(view.header+12+(stageHeight-closedCut)*placement.scale, Math.min(view.top + view.height - 12, held.placement.anchor + dy));
        render(); return;
      }
      if (cycle !== 'showing') return;
      const verticalDistance=event.clientY-held.y;
      if(!held.moved && event.pointerType==='touch' && Math.abs(verticalDistance)>8 && Math.abs(verticalDistance)>Math.abs(distance)){
        const press=held;held=null;suppressUntil=Date.now()+500;
        if(press.element.hasPointerCapture(event.pointerId)) press.element.releasePointerCapture(event.pointerId);
        lastTime=performance.now();return;
      }
      if (!held.moved && (Math.abs(distance)<7 || (event.pointerType==='touch' && Math.abs(distance)<=Math.abs(verticalDistance)))) return;
      held.moved = true; event.preventDefault(); turn = null;
      phase = held.phase - distance / Math.max(1,ticket.getBoundingClientRect().width);
      root.dataset.dragDelta = String(distance); paintSlides();
    }, options);
    const release = event => {
      if (!held || held.id !== event.pointerId) return;
      const completed = held; held = null;
      if (completed.moved && completed.mode === 'dock') {
        const view = dimensions();
        const dx = event.clientX - completed.x;
        const side = dx > 12 ? 'right' : dx < -12 ? 'left' : placement.left + 170 * placement.scale > view.left + view.width / 2 ? 'right' : 'left';
        dockPosition = { side, anchor: (placement.anchor - view.top) / view.height };
        save(visit + 'dock',JSON.stringify(dockPosition));
        place('dock'); if (placementMotion) placementMotion.duration = 240;
      } else if (completed.moved) {
        const target = Math.round(phase);
        turn = reduced.matches ? null : { from: phase, to: target, time: 0, duration: 340 };
        if (reduced.matches) phase = target;
        nextTurn = interval; manualPaused = false;
      }
      // A stationary press on the closed box is a tap even when held slowly.
      // Long presses on an open product still must not accidentally follow it.
      if (completed.moved || completed.mode === 'carousel' && completed.cycle === 'showing' && performance.now() - completed.began > 240 || event.type !== 'pointerup') suppressUntil = Date.now() + 500;
      if (completed.element.hasPointerCapture(event.pointerId)) completed.element.releasePointerCapture(event.pointerId);
      lastTime = performance.now(); render();
    };
    root.addEventListener('pointerup', release, options); root.addEventListener('pointercancel', release, options); root.addEventListener('lostpointercapture', release, options);
    root.addEventListener('dragstart', event => event.preventDefault(), options);
    root.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); navigate(event.key === 'ArrowRight' ? 1 : -1); }
      else if(event.key==='Escape' && cycle==='showing'){event.preventDefault();beginReturn();render();}
    }, options);
    root.addEventListener('focusout', () => { lastTime = performance.now(); }, options);
    document.addEventListener('keydown', () => { keyboardIntent = true; }, { ...options, capture: true });
    document.addEventListener('pointerdown', () => { keyboardIntent = false; }, { ...options, capture: true });
    document.addEventListener('pointermove',event=>{
      if(event.pointerType==='touch'||!placement)return;
      root.dataset.hovered=String(root.contains(event.target));
    }, {...options,passive:true});
    modal.querySelector('[data-coupon-dialog-close]').addEventListener('click', () => modal.close(), options);
    modal.addEventListener('close', () => { lastTime = performance.now(); availability(); }, options);
    modal.addEventListener('click', event => { if (event.target === modal) { const r = modal.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) modal.close(); } }, options);
    modal.querySelectorAll('a[data-coupon-offer]').forEach(link => link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      event.preventDefault();
      const destination = link.href;
      modal.close();
      manualPaused = false; keyboardIntent = false; held = null; turn = null; placementMotion = null;
      snoozeUntil = 0; save(visit + 'until','0');
      progressLid = 0; progressPanel = 0; returnPose = { lid: 0, panel: 0 };
      place('dock',false); selectCycle('closed'); render(); persist();
      window.setTimeout(() => window.location.assign(destination), reduced.matches ? 0 : 180);
    }, options));
    modal.querySelectorAll('[data-coupon-subscribe]').forEach(button => button.addEventListener('click', () => {
      modal.close();
      save('cyfie-welcome-home-shown','true');
      if (welcome && !welcome.open) {
        welcome.showModal();
        return;
      }
      const fallback = button.dataset.fallbackLink || (button.dataset.discountCode ? `/discount/${encodeURIComponent(button.dataset.discountCode)}?redirect=${encodeURIComponent('/collections/all')}` : '/collections/all');
      window.location.assign(fallback);
    }, options));
    const reposition = () => {
      if(layout!=='dock' && cycle!=='waiting' && !composition().fits){
        manualPaused=false;turn=null;progressLid=0;progressPanel=0;returnPose={lid:0,panel:0};
        place('dock',false);selectCycle('closed');render();return;
      }
      if (placementMotion) placementMotion.to = targetPlacement(layout);
      else placement = targetPlacement(layout);
      render();
    };
    window.addEventListener('resize', reposition, { ...options, passive: true }); window.addEventListener('scroll', reposition, { ...options, passive: true });
    visualViewport?.addEventListener('resize', reposition, { ...options, passive: true }); visualViewport?.addEventListener('scroll', reposition, { ...options, passive: true });
    mobile.addEventListener('change', () => { if(layout!=='dock'&&!composition().fits){reposition();return;}place(layout === 'dock' ? 'dock' : mobile.matches ? 'center' : 'featured',false); render(); }, options);
    wide.addEventListener('change', reposition, options);
    reduced.addEventListener('change', () => { if (reduced.matches && turn) { phase = turn.to; turn = null; } if (reduced.matches && placementMotion) { placement = placementMotion.to; placementMotion = null; } lastTime = performance.now(); render(); }, options);
    welcome?.addEventListener('close', releaseWelcomeGate, options);
    window.addEventListener('cyfie:signup-popup-closed', releaseWelcomeGate, options);
    window.addEventListener('cyfie:signup-popup-skipped', releaseWelcomeGate, options);
    document.addEventListener('visibilitychange', availability, options);
    const observer = new MutationObserver(availability);
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'], childList: true });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root) || event.target.contains(home)) { disposed = true; cancelAnimationFrame(frame); observer.disconnect(); controller.abort(); if (root.hasAttribute('popover') && root.matches(':popover-open')) root.hidePopover(); if (modal.open) modal.close(); } }, options);
    const persist = () => {
      if(designer)return;
      save(visit + 'runtime-v3', JSON.stringify({ version: 3, customer, offers: offerSignature,
        cycle, elapsed, phase, exposure, nextTurn, turn, layout, returnPose,
        manualPaused, burstCount, openCount, dropCount, shakeCount, idleShakeBand }));
    };
    const restore = value => {
      closeCount = designer ? 0 : Math.min(2, Number(read(visit + 'closes')) || 0);
      snoozeUntil = designer ? 0 : Number(read(visit + 'until')) || 0;
      dismissed = closeCount >= 2;
      held = null; placementMotion = null; keyboardIntent = false;
      if (value) {
        cycle = value.cycle; elapsed = value.elapsed; phase = value.phase;
        exposure = slides.map((_,index) => Math.max(0,Math.min(minimumExposure,Number(value.exposure?.[index]) || 0)));
        nextTurn = Number.isFinite(value.nextTurn) ? value.nextTurn : interval;
        turn = value.turn && ['from','to','time','duration'].every(key => Number.isFinite(value.turn[key])) && value.turn.duration > 0 ? { ...value.turn } : null;
        layout = value.layout === 'dock' ? 'dock' : mobile.matches ? 'center' : 'featured';
        returnPose = value.returnPose || { lid: 1, panel: 1 };
        manualPaused = Boolean(value.manualPaused); burstCount = Number(value.burstCount) || 0;
        openCount = Number(value.openCount) || 0; dropCount = Number(value.dropCount) || 0;
        shakeCount = Number(value.shakeCount) || 0; idleShakeBand = Number(value.idleShakeBand) || 0;
      } else {
        cycle = 'waiting'; elapsed = 0;
        layout = mobile.matches ? 'center' : 'featured';
      }
      if (dismissed) { cycle = 'dismissed'; elapsed = 0; }
      else if (snoozeUntil > Date.now()) { cycle = 'snoozed'; elapsed = 0; layout = 'dock'; }
      else if (cycle === 'snoozed' || cycle === 'dismissed' || !value && closeCount === 1) {
        cycle = 'closed'; elapsed = 0; idleShakeBand = 0; layout = 'dock';
      }
      // Old visits can have saved an open card at the closed mobile dock scale.
      const openScene=['dropping','opening','showing','retracting'].includes(cycle);
      if(openScene && layout==='dock' && composition().fits) layout=mobile.matches?'center':'featured';
      if(cycle!=='waiting' && (layout!=='dock'||openScene) && !composition().fits){
        cycle='closed';elapsed=0;layout='dock';returnPose={lid:0,panel:0};turn=null;manualPaused=false;
      }
      place(layout,false); render(); availability(); lastTime = performance.now();
      root.dataset.resumed = String(Boolean(value));
    };
    window.addEventListener('pagehide', persist, options);
    window.addEventListener('pageshow', event => {
      if (event.persisted) restore(readRuntime());
      lastTime = performance.now(); availability();
    }, options);
    document.addEventListener('visibilitychange', () => { if (document.hidden) persist(); }, options);
    // Establish source-calibrated opening bounds before choosing the scene size.
    renderCard(ticket,0,0,1,0,1,224);
    restore(designer || !welcomeClosed ? null : readRuntime());
    root.dataset.ready = 'true';
    Promise.all([artworkReady.catch(() => {}), ...[...body.querySelectorAll('img')].map(image => image.decode?.().catch(() => {}) ?? Promise.resolve())]).then(() => { assetsReady = true; lastTime = performance.now(); });
    frame = requestAnimationFrame(tick);
  };
  document.querySelectorAll('[data-coupon-offers]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('[data-coupon-offers]')));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.story-banner-section__video-toggle');
    if (!button) return;
    var shell = button.closest('.story-banner-section__shell');
    var video = shell && shell.querySelector('.story-banner-section__video');
    if (!video) return;
    if (video.paused) {
      video.play();
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', '영상 일시정지');
    } else {
      video.pause();
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', '영상 재생');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
